export default "__VITE_ASSET__DchIQySg__"